import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="kredit-zinsbindung-annuitaet"
export default class extends Controller {
	static targets = ["annuitaetLabel", "intervall"]

	connect() {
		this.updateLabel()
	}

	updateLabel() {
		this.annuitaetLabelTarget.textContent = this.labelText(this.intervallTarget.value)
	}

	labelText(intervall) {
		switch (intervall) {
			case "1":
				return "Monatliche Annuität"
			case "3":
				return "Vierteljährliche Annuität"
			case "6":
				return "Halbjährliche Annuität"
			case "12":
				return "Jährliche Annuität"
			default:
				return "Annuität"
		}
	}
}
